import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { TabellaDifferenze as Original } from 'components/organisms'
import {
  TabellaDifferenzeSettings,
  TabellaDifferenzeFloatingSettings,
} from './TabellaDifferenzeSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { tabellaDifferenzeCardItemParams } from '../TabellaDifferenzeCard'

export const defaultProps = {}

export const tabellaDifferenzeItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
  children: getItemChildren(enabled, children?.[2], tabellaDifferenzeCardItemParams),
})

export const dynamicProps = []

export const TabellaDifferenze: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-tabella-differenze ${props.className}`}
      >
        <Original
          item={tabellaDifferenzeItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

TabellaDifferenze.craft = withCraft({
  name: 'TabellaDifferenze',
  defaultProps: defaultProps,
  settings: TabellaDifferenzeSettings,
  floatingSettings: TabellaDifferenzeFloatingSettings,
})
